"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = exports.device = void 0;
var theme = {
  button: {
    simple: {
      bgColor: "#0a46a5",
      hoverBgColor: "rgba(10, 70, 165, .5)",
      fontColor: "#fff",
      hoverFontColor: "#000",
      borderColor: "#0a46a5"
    },
    halfBg: {
      bgColor1: "#8de9ff",
      bgColor2: "000",
      fontColor: "#000",
      hoverFontColor: "#ddd",
      iconFill: "#000"
    }
  }
};
exports.theme = theme;
var responsiveSizes = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  desktop: "2560px"
};
var device = {
  mobileS: "(min-width: ".concat(responsiveSizes.mobileS, ")"),
  mobileM: "(min-width: ".concat(responsiveSizes.mobileM, ")"),
  mobileL: "(min-width: ".concat(responsiveSizes.mobileL, ")"),
  tablet: "(min-width: ".concat(responsiveSizes.tablet, ")"),
  laptop: "(min-width: ".concat(responsiveSizes.laptop, ")"),
  laptopL: "(min-width: ".concat(responsiveSizes.laptopL, ")"),
  desktop: "(min-width: ".concat(responsiveSizes.desktop, ")"),
  desktopL: "(min-width: ".concat(responsiveSizes.desktop, ")")
};
exports.device = device;